// ReleaseNote6.jsx
import { Box, Typography } from "@mui/material";

const ReleaseNote6 = () => {
  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Release 6.0
      </Typography>

      <Typography variant="body2" sx={{ mb: 3 }}>
        This release introduces enhancements to the Reference Extractor, improving extraction accuracy and reporting capabilities within JUNE.
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          <strong>Key Updates and Enhancements</strong>
        </Typography>

        <ul style={{ margin: 0, paddingLeft: "5%" }}>
          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>Reference Extractor – Enhancement</strong>
            </Typography>
            <ul style={{ margin: "8px 0 0 0", paddingLeft: "5%" }}>
              <li style={{ marginBottom: "8px" }}>
                <Typography variant="body2">
                  Improved extraction accuracy for both patent and non-patent
                  literature (NPL) references.
                </Typography>
              </li>
              <li style={{ marginBottom: "8px" }}>
                <Typography variant="body2">
                  Added a structured Excel output with separate Patent and NPL
                  reference columns, identified page numbers, and probable NPL
                  publication titles for easier review and analysis.
                </Typography>
              </li>
            </ul>
          </li>
        </ul>

        <Typography variant="body2" sx={{ mt: 1}}>
          Refer to the FAQ and Tutorial sections for more details on this feature.
        </Typography>
      </Box>
    </Box>
  );
};

export default ReleaseNote6;
